import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CustomEventNewCardEnt } from '../../interfaces/custom-event-new-card-ent';
import { Router } from '@angular/router';
import utils from 'src/app/utils/utils';
import { EventsNews } from 'src/app/utils/enums/events-new';

@Component({
  selector: 'custom-card-events-news',
  templateUrl: './custom-card-events-news.component.html'
})
export class CustomCardEventsNewsComponent implements OnInit {
  @Input() eventNew : CustomEventNewCardEnt  = new CustomEventNewCardEnt;
  @Input() type: EventsNews = EventsNews.NEWS;
  @ViewChild('eventDescription') eventDescription!: ElementRef<HTMLElement>;
  textWithoutTags : string = '';
  label: string = '';
  date?: Date;

  constructor(
    private readonly _router: Router
  ){}

  ngOnInit(): void {
    this.label = 'Fecha Publicación';
    this.date = this.eventNew.createdAt;
    if(this.type == 'events') {
      this.label = 'Fecha Evento';
      this.date = this.eventNew.eventDate;
    }
    this.textWithoutTags= utils.replacetHtmlTags(this.eventNew.content!);
  }

  sendWithState(event: any){
    this._router.navigate([`/${this.type}/full-size`], {
      state: {
        key: 1,
        data: event
      }
    })
  }
}
